import { pathOr } from 'ramda'
import {
  FILTER_CHANGE,
  ADULTS_DEFAULT,
  ADULTS_ONE_DAY_BOOKING,
  CHILDREN_DEFAULT,
  BABIES_DEFAULT,
  FILTER_ROOMS,
} from '../../search/constants'
import {generateId} from 'js/helpers/generate';

const oneDayBooking = pathOr(null, ['drupalSettings', 'oneDayBooking'], window)
export const addRoom = (dispatch, state) => {
  const { form: { searchFilters: { rooms } } } = state
  const updatedRooms = [
    ...(rooms || []),
    {
      adults: oneDayBooking ? ADULTS_ONE_DAY_BOOKING : ADULTS_DEFAULT,
      children: CHILDREN_DEFAULT,
      childrenAge: [],
      babies: BABIES_DEFAULT,
      visible: true,
      id: generateId(),
    },
  ]

  dispatch({
    type: FILTER_CHANGE,
    filterType: FILTER_ROOMS,
    values: updatedRooms,
  });
  return updatedRooms;
}

export default () => (dispatch, getState) => addRoom(dispatch, getState())
